var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c("StepTitle", [_vm._v("Movimientos")]),
                  _c("v-divider"),
                  _c("br"),
                  _c("CabeceraTabla", {
                    scopedSlots: _vm._u([
                      {
                        key: "izquierda",
                        fn: function() {
                          return [
                            _c("BuscadorOperacionCrud", {
                              attrs: {
                                filter:
                                  _vm.gridApi &&
                                  _vm.gridApi.setQuickFilter.bind(_vm.gridApi)
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ])
                  }),
                  _c(
                    "div",
                    { attrs: { align: "left" } },
                    [
                      _c("MantenedorGrid", {
                        attrs: { "grid-options": _vm.gridOptions }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }